import { useCallback } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/api/client";
import { queryKeys } from "@/lib/queryKeys";

export interface License {
  plan: string;
  features: string[];
  seats: number;
  seats_used: number;
  status: string;
  expires_at: string;
  created_at: string;
  has_stripe_customer?: boolean;
  granted_by_member_id?: string | null;
  grantor_partner_id?: string | null;
  billing_period?: string | null;
  pending_cancellation_at?: string | null;
  canceled_at?: string | null;
}

export function useLicense() {
  // swallowed today — license=null on any failure, error never set
  // (pre-existing behavior, preserved).
  const query = useQuery({
    queryKey: queryKeys.license.current(),
    queryFn: async () => {
      try {
        return await api<License>("/api/v2/license");
      } catch {
        return null;
      }
    },
  });

  const refetch = useCallback(() => {
    void query.refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query.refetch]);

  return {
    license: query.data ?? null,
    loading: query.isLoading,
    error: "",
    refetch,
  };
}
